import axios from 'axios';
import { showError } from '../components/Alerts';

/**
 * Maneja errores de API mostrando el mensaje del backend cuando está disponible,
 * o un mensaje genérico como fallback.
 */
export const handleApiError = (error: any, customMessage?: string): void => {
  if (process.env.NODE_ENV === 'development') {
    console.error('API Error:', error);
  }

  if (axios.isAxiosError(error) && error.response?.data) {
    const backendMessage =
      error.response.data.message || error.response.data.error;

    if (backendMessage && typeof backendMessage === 'string') {
      showError(backendMessage);
      return;
    }
  }

  showError(customMessage || 'Ha ocurrido un error inesperado');
};

/**
 * Manejador para operaciones de creación
 */
export const handleCreateError = (
  error: any,
  resourceName: string = 'registro',
): void => {
  handleApiError(error, `Error al crear ${resourceName}`);
};

/**
 * Manejador para operaciones de actualización
 */
export const handleUpdateError = (
  error: any,
  resourceName: string = 'registro',
): void => {
  handleApiError(error, `Error al actualizar ${resourceName}`);
};

/**
 * Manejador para operaciones de eliminación
 */
export const handleDeleteError = (
  error: any,
  resourceName: string = 'registro',
): void => {
  handleApiError(error, `Error al eliminar ${resourceName}`);
};

/**
 * Manejador para operaciones de carga/obtención
 */
export const handleLoadError = (
  error: any,
  resourceName: string = 'datos',
): void => {
  handleApiError(error, `Error al cargar ${resourceName}`);
};
